import { render } from "./IconDelete.vue?vue&type=template&id=7c75bb4e"
const script = {}

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__